// extracted by mini-css-extract-plugin
export default {"Addressees":"styles_Addressees__C7MAr","title":"styles_title__cT5CL","addresseesContainer":"styles_addresseesContainer__H4JLa","addMoreButton":"styles_addMoreButton__0ZBAv"};